import { isThursday, isFriday, isSaturday, isSunday } from 'date-fns';

export const isLastTwoDaysOfWeek = (date, { weekStartsOn = 0 } = {}) => {
  const startsOnMonday = weekStartsOn !== 0;

  if (startsOnMonday) {
    return isSaturday(date) || isSunday(date);
  }

  return isFriday(date) || isSaturday(date);
};

export const isLastThirdDayOfWeek = (date, { weekStartsOn = 0 } = {}) => {
  const startsOnMonday = weekStartsOn !== 0;

  return startsOnMonday ? isFriday(date) : isThursday(date);
};
